import React from 'react'
import { connect } from 'react-redux'
import { AnimatePresence } from 'framer-motion'
import styled from 'styled-components'
import ToastItem from './ToastItem'

const ToastContainer = styled.div`
  float: right;
  position: absolute;
  top: 0;
  right: 0;
  width: 250px;
  padding-top: 85px;
  margin-right: 25px;
`

const ToastList = (props) => {
  return (
    <ToastContainer>
      <ul
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 9999,
          listStyle: 'none',
          margin: 0,
          padding: 0,
          width: '350px',
        }}
      >
        <AnimatePresence initial={false}>
          {props.toasts && props.toasts.length > 0
            ? props.toasts.map((toast, i) => <ToastItem key={i} toast={toast} />)
            : null}
        </AnimatePresence>
      </ul>
    </ToastContainer>
  )
}

const mapStateToProps = (state) => ({
  toasts: state.company.toasts,
})

export default connect(mapStateToProps, null)(ToastList)
